// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./vendor/vi-kon/laravel-admin/src/resources/assets/bootstrap/bootstrap.less
// module id = 307
// module chunks = 0